<!-- JOB VIEW TEMPLATE (clean, single hero + description) -->
<div class="container mt-5" *ngIf="currentStep === 1">
  <div *ngIf="!loading">
    <div *ngIf="jobDetail; else errorTpl">

      <!-- HERO IMAGE SECTION WITH OVERLAY ROLE NAME + APPLY BUTTON -->
      <div class="job-hero">
        <div class="job-hero__wrapper">
<img
  class="job-hero__image"
  [src]="jobDetail?.image || 'assets/images/career.jpeg'"
  [alt]="jobDetail?.title || 'Job image'"
  loading="lazy"
/>

<div class="job-hero__label">
  <div class="job-title">
    {{ jobDetail?.title }}
  </div>

  <div class="job-meta">
    Experience: {{ jobDetail?.min_experience }} - {{ jobDetail?.max_experience }} yrs |
    Salary: {{ jobDetail?.min_ctc }} - {{ jobDetail?.max_ctc }} LPA 
  </div>

  <a class="apply-btn" routerLink="/apply-job" href="/apply-job">
    Apply Now
  </a>
</div>

        </div>
      </div>

      <!-- ROLE & RESPONSIBILITIES CARD -->
      <div class="job-card shadow-sm">
        <h1 class="section-title">Role & Responsibilities</h1>
        <br />

        <div [innerHTML]="formattedDescription"></div>
      </div>

    </div>

    <!-- LOADING -->
    <div class="loading-container text-center my-5" *ngIf="loading">
      <img src="assets/images/favicon.png" alt="Loading..." class="loading-image" />
    </div>
  </div>

  <!-- ERROR BLOCK -->
  <ng-template #errorTpl>
    <div class="alert alert-danger">{{ errorMessage }}</div>
  </ng-template>
</div>

<!-- APPLY FORM (STEP 2) -->
<div class="container mt-5" *ngIf="currentStep === 2">
  <div class="col-lg-5 mx-auto">
    <div class="card p-4 shadow">
      <h4 class="mb-3 heading">Apply</h4>

      <form [formGroup]="applyForm" (ngSubmit)="onSubmit()">

        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Full Name"
            formControlName="fullName"
          />
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('fullName')?.touched && applyForm.get('fullName')?.invalid">
            Full Name is required
          </div>
        </div>

        <div class="mb-3">
          <input
            type="email"
            class="form-control"
            placeholder="Email Address"
            formControlName="email"
          />
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('email')?.touched && applyForm.get('email')?.invalid">
            <div *ngIf="applyForm.get('email')?.errors?.['required']">
              Email is required
            </div>
            <div *ngIf="applyForm.get('email')?.errors?.['email']">
              Invalid email address
            </div>
          </div>
        </div>

        <div class="mb-3">
          <input
            type="number"
            class="form-control"
            placeholder="Phone Number"
            formControlName="phone"
          />
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('phone')?.touched && applyForm.get('phone')?.invalid">
            <div *ngIf="applyForm.get('phone')?.errors?.['required']">
              Phone number is required
            </div>
            <div *ngIf="applyForm.get('phone')?.errors?.['pattern']">
              Phone number must be 10 digits
            </div>
          </div>
        </div>

        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Location (City)"
            formControlName="location"
          />
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('location')?.touched && applyForm.get('location')?.invalid">
            Location is required
          </div>
        </div>

        <div class="mb-3">
          <input
            type="file"
            class="form-control"
            (change)="onFileChange($event)"
            accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
          />
          <div class="text-danger mt-1" *ngIf="fileError">
            Please upload your resume
          </div>
        </div>

        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Years of Experience"
            formControlName="experience"
          />
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('experience')?.touched && applyForm.get('experience')?.invalid">
            Experience is required
          </div>
        </div>

        <div class="form-check mb-3">
          <input
            type="checkbox"
            class="form-check-input"
            formControlName="agreement"
          />
          <label class="form-check-label">
            I agree to the processing of my personal data
          </label>
          <div
            class="text-danger mt-1"
            *ngIf="applyForm.get('agreement')?.touched && applyForm.get('agreement')?.invalid">
            You must accept the agreement
          </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
        <button
          class="btn btn-primary w-50"
          type="submit"
          [disabled]="submitting">
          {{ submitting ? 'Submitting...' : 'Submit Application' }}
        </button>
        </div>
      </form>
    </div>
  </div>
</div>

<br /><br />
